import { Component } from '@angular/core';

@Component({
  selector: 'integrations-disconnect-element',
  templateUrl: './disconnect-element.component.html',
  standalone: false,
})
export class DisconnectElementComponent {}
